<template>
    <div>
        <div>
            <el-dialog :visible.sync="dialogVisible" width="50%">
                <b-form-group label="Series Name:" label-for="filterInput">
                    <b-form-input id="filterInput" v-model="series_name" type="text" required placeholder="Series Name" />
                </b-form-group>

                <trait-select-form 
                    :is-emit-to-parent="isEmitToParent" 
                    :is-emit-edit-to-parent="isEmitEditToParent" 
                    :edit-traits-info="editTraitsInfo" 
                    @emitTraitForms="emitTraitForms($event)"
                    @updateForm="updateForm($event)"
                />

                <v-card-actions>
                    <v-spacer />
                    <br>
                    <br>
                    <v-btn color="primary" class="v-btn-bold-color" @click="saveParams()">Save</v-btn>
                </v-card-actions>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    props: ["tableId","dialog", "isEdit", "selectId"],
    data () {
        return {
            series_name: "",

            // Dialog Show or not show
            dialogVisible: false,

            TraitInfo: "",
            isEmitToParent: false,

            // Get All Traits For EDIT
            editTraitsInfo: [],
            seriesTraitId: 0,
            isEmitEditToParent: false,
        };
    },
    watch: {
        dialogVisible() {
            this.$emit("update:dialog", this.dialogVisible);
            this.$emit("update:isEdit", this.dialogVisible);
            if (this.dialogVisible == false && this.selectId) this.$emit("update:selectId", "");
        },
        dialog() {
            this.dialogVisible = this.dialog;
            this.series_name = "";
        },
        isEdit() {
            var self = this;
            if (this.isEdit == true && this.selectId != "") {
                self.getEditSeries();
            }
        }
    },
    methods: {
        getEditSeries() {
            var self = this;
            axios({
                method: "GET",
                url: "SeriesTrait/GetAll",
                params: {
                    "SeriesId": self.selectId,
                },
            })
                .then(function (response) {
                    self.editTraitsInfo = response.data.result.items;
                    self.seriesTraitId = response.data.result.items[0].id;
                    self.series_name = response.data.result.items[0].series.name;
                });
        },
        updateForm(event) {
            this.isEmitEditToParent = false;
            alert("update");
            // var self = this;
            // axios({
            // 	method: 'PUT',
            // 	url: 'Series/Update',
            // 	data:{
            // 		"id": self.selectId,
            // 		"name": self.series_name,
            // 	},
            // })
            // .then(function (response) {
            // 	self.dialogVisible = false;
            // 	self.reloadTable('#'+self.tableId);
            // 	self.updateSeriesTrait(event);
            // })
        },
        updateSeriesTrait(event) {
            console.log(event);
            var self = this;
            event.forEach(function(element) {	
                axios({
                    method: "PUT",
                    url: "SeriesTrait/Update",
                    data: {
                        "id": self.seriesTraitId,
                        "seriesId": self.selectId,
                        "traitId": element.traitId,
                        "minValue": element.minValue,
                        "maxValue": element.maxValue
                    },
                });
            });
        },
        emitTraitForms(event) {
            this.isEmitToParent = false;
            var self = this;
            axios({
                method: "POST",
                url: "Series/CreateSeriesWithTrait",
                data: {
					  	"name": self.series_name,
					  	"isPublic": true,
					  	"seriesTraits": event
                },
            })
                .then(function (response) {
                    self.dialogVisible = false;
                    self.reloadTable("#" + self.tableId);
                });
        },
        saveParams() {
            if (this.selectId) {
                this.isEmitEditToParent = true;
                // this.updateForm();
            } 
            else this.isEmitToParent = true;
        }
    }
};
</script>

<style scoped>
.formInlineText{
	margin: 0 1rem;
}
/*.plusBtn{
	color: #007bff;
}*/
</style>


// WEBPACK FOOTER //
// src/smallComponents/traitDialog-Edit.vue